<template>
  <section class="reports-table">
    <article class="reports-table__body">
      <div class="reports-table__body-header">
        <h2 class="reports-table__body-title">Reports</h2>
        <TableSearchbar @search="setSearch" />
      </div>
      <BaseTable id="reports-table" :sticky-header="false">
        <template #thead>
          <tr>
            <th>&nbsp;&nbsp;</th>
            <th>Name</th>
            <th>Primary Point of Contact</th>
            <th>Primary Data Submission Contact</th>
            <th></th>
          </tr>
        </template>
        <template v-if="users && users.length > 0" #tbody>
          <tr v-for="report in reports.data" :key="`report-row-${report.id}`">
            <td>&nbsp;&nbsp;</td>
            <td>
              {{ report.name }}
            </td>
            <td>
              <BaseSelectDropdown
                id="reports-table__poc-select"
                :modelValue="
                  report.consulting_meta
                    ? report.consulting_meta.contact_user_id
                    : null
                "
                :placeholder-text="`Select contact`"
                :options="getReportUserOptions(report)"
                button-size="sm"
                class="reports-table__contact-select"
                @update:modelValue="setPrimaryPOC($event, report)"
              />
            </td>
            <td>
              <BaseSelectDropdown
                id="reports-table__data-select"
                :modelValue="
                  report.consulting_meta
                    ? report.consulting_meta.data_user_id
                    : null
                "
                :placeholder-text="`Select contact`"
                :options="getReportUserOptions(report, true)"
                button-size="sm"
                class="reports-table__contact-select"
                @update:modelValue="setPrimaryDataContact($event, report)"
              />
            </td>
            <td>
              <a
                :href="`/consulting/report/${report.encrypted_id}`"
                target="_blank"
                class="reports-table__report-link"
              >
                View Report
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <rect width="25" height="25" fill="url(#pattern0)" />
                  <defs>
                    <pattern
                      id="pattern0"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use
                        xlink:href="#image0_5893_921"
                        transform="scale(0.005)"
                      />
                    </pattern>
                    <image
                      id="image0_5893_921"
                      width="200"
                      height="200"
                      xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE7mlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNy4yLWMwMDAgNzkuNTY2ZWJjNSwgMjAyMi8wNS8wOS0wNzoyMjoyOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnBob3Rvc2hvcD0iaHR0cDovL25zLmFkb2JlLmNvbS9waG90b3Nob3AvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIzLjQgKFdpbmRvd3MpIiB4bXA6Q3JlYXRlRGF0ZT0iMjAyMy0wMy0yMVQxMjoyNzo0MS0wNDowMCIgeG1wOk1vZGlmeURhdGU9IjIwMjMtMDMtMjFUMTI6Mjg6MjUtMDQ6MDAiIHhtcDpNZXRhZGF0YURhdGU9IjIwMjMtMDMtMjFUMTI6Mjg6MjUtMDQ6MDAiIGRjOmZvcm1hdD0iaW1hZ2UvcG5nIiBwaG90b3Nob3A6Q29sb3JNb2RlPSIzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjFlOWFiMTRjLWI5ZWItNzM0Yi04MjFiLWRiMjc2M2ViNzVkOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxZTlhYjE0Yy1iOWViLTczNGItODIxYi1kYjI3NjNlYjc1ZDkiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxZTlhYjE0Yy1iOWViLTczNGItODIxYi1kYjI3NjNlYjc1ZDkiPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjFlOWFiMTRjLWI5ZWItNzM0Yi04MjFiLWRiMjc2M2ViNzVkOSIgc3RFdnQ6d2hlbj0iMjAyMy0wMy0yMVQxMjoyNzo0MS0wNDowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIzLjQgKFdpbmRvd3MpIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlCtvgEAAAs7SURBVHic7d1rsFVlHcfx7+Yc7vcCgyTQvFXiDKZIoKaRmBOm081EJkkMFJwyx4EkmoJKSmEKoRRNGO2iOVnpmFoKMhTyivDC0ICNCOXEC8EGE1Q4h92L55xyGnzO2Xv9n/U8a63fZ4Zpps7674fT/rL2ZV1q9XodETm6HrEXIJIyBSLioUBEPBSIiIcCEfFQICIeCkTEQ4GIeCgQEQ8FIuKhQEQ8FIiIhwIR8VAgIh4KRMRDgYh4KBARDwUi4tFqNWjkpJlWoyQfo4E5wEXAyUC/uMtp2kHgNmARcKjzv9yzaY3JcO1BqqcGLABeAG4CxlHcOMCtfQGwCXi/9XAFUj2rgCVA79gLMXYG8DQwynKoAqmWucDs2IsIaATwIIbPawVSHYNxe46ymwBMtRqmQKpjGi6SKniP1SAFUh2TYy8gRwpEGjYm9gJy9F6rQQpEyqjFapACqY5dsRdQRAqkOp6KvYAiUiDVcT/wr9iLKBoFUh2v4Q4tkQYokGq5C7gj9iKKRIFUz1xgPvBm7IUUgQKppqXAScDNwBbgQNzlpEuBVNfLwDdxR8EOwB0GH+rPF4C2fP5athSIhHY5cB+GJ+flSYFISNOAX2D4zXbeUq+6NzAcGIg7c6wWdznBvQXsxn0kW3TTgXspcByQXiCnAx8HzgNOxR1gV7W9XB34C+7j2HuB9rjLacoXgXsowf93KQQyApgFXAmcGHktKagBZwKrgWuAz+LeUBfFDGANJYgD4gYyEvcpykygT8R1pOwsYCMwEdgTeS3dcRVwNyWJA+L8RVqArwHbcV9aKQ6/MbiXWqm7GrfXK00ckP9fZiSwFvgRMCjnxy6yKR1/UjUL+Ckl/BAlz0DGA88C5+f4mGXypdgLeAezgTspYRyQXyBTgPXAMTk9XhmdE3sBRzEHd50t6zgOG89rWh6BnAM8DPTP4bHKzOw8ayPXAbdjH8dzwGLjmU0LHcgHgEeAvoEfpwreir2At/kK8OMAc5/DfQ+2L8DspoQMpC/wa2BIwMeoku2xF9DhemBFgLnJxQFhA1kKjA04v2oei70A3MfzywPMTTIOCBfIeNwbOLFxEPdmOKYbcR/PW0s2DggXyIqAs6toIfDPiI8/D1gWYG7ScUCYJ/EU4CMB5lbVCsK8rOmurwO3BpibfBwQJpB5AWZW0V7csU3XR1zDAuAHAeYWIg6wP1hxNHCB8cw24CXKcY5EV94EdgLrcPe5iHmu+ELgewHmFiYOsA9kOnZfHG3B7dp/jy4qkLdvEebLukLFAfaBXGQwow58AxfHEYN50phFwLcDzC1cHGAbSF9s3pzPwR38JvlbjNt7WCtkHGAbyFigV8YZ96E4Yvku7gQ2a4WNA2wDOSXj9u24l1aSv5sJ87svdBxgG8jxGbdfj7uih+Tr+4S5qHXh4wDbQLLeIPJpk1VII24lzPdWpYgDbAMZkHH7IlyUoEyW4Y6vslaaOMA2kKyzinj9p6L6IXBDgLmligPSuC6W5Gs5YQ5fKV0coECqZgXubEBrpYwDFEhV1ICVuPPIrZU2DlAgVVADfkKYE9hKHQcokLKr4S6CfU2A2aWPAxRImdVwh+3MCjA7dBz1yNv/lwIppxruUqBXB5idx54j6w1GD5qsAgVSRj1wV1i/KsDsvF5W7ci4vdklknRhhXLpgbs3R5HjANgMvNLktkeAP1gtRIGURw/cXZ1mBJid9xvyNtzH0s14EPiH1UIUSDm0AD/D3frMWqxPq5YB2xrc5lWMjy9TIMXXGcf0ALNjfpT7BnAxsKubP/8acAnGt6tTIMXWgrvN8hUBZqfwPccu3FU6H+ji5/7c8XPmp0zoU6ziagV+CVwWYHYKcXTaC1yOOyX4MtwNTofh9hjPA7/D3ccxCAVSTK3A/cDnAsxOKY6320aYq614KZDi6Qn8CvhMgNmpxhGNAimWnrjX458OMFtxHIUCKY6euBsSXRpgtuJ4BwqkGHrhvgD7VIDZisNDgaSvN/AbYGqA2YqjCwokbb2B3wKfDDBbcXSDAklXH9xn/BYXBP9/iqObFEia+gAPAZ8IMFtxNECBpKcv8DDuVnbWFEeDFEha+gKP4J7E1hRHE3SwYjr64e6mpTgSoj1IGvoBjwLnB5itODLQHiS+/sBjKI4kaQ8S1wBcHOcGmK04DGgPEs9A3MUFyhjHaNyNeZ7B3aG4Dfg77hZ7F0ZaU1MUSBydcZwdYHbMOGrAAuAF3F2rxuHeX7UA7wOmAX/s+DMiwvoapkDyNwj3BJkUYHbsPccqYAnuEBmfC4FNwLHBV5SRAsnXYOAJYGKA2bHjmAvMbuDnj8cdvp/0czDpxZVMZxwTAsyOHcdg3J6jURMJczUWMwokH0OAtcBZAWbHjgPce4tmb+J6reVCrCmQ8Ibi4jgzwOwU4gCYnGHbCbg38klSIGG9C1gHnBFgdipxAIzJsG0L7mPhJCmQcN6Ni+P0ALNTigO6/tSqK31MVhGAAgljGC6OcQFmpxZHqelQE3vDcXGcFmC24siZArE1HHgKGBtgtuKIQC+x7BwDrEdxlIoCsTEE97Lq1ACzFUdECsTGXWjPUUoKJLuJwOcDzFUcCVAg2c0MMFNxJEKBZPdR43mKIyEKJLtRhrMUR2IUSHZtRnMUR4IUSHYvGsxQHIlSINk9mXF7xZEwBZLdncDhJrdVHIlTINntBG5pYjvFUQAKxMYi3AUIumsLiqMQFIiNdtx52d8BDnXxs/cA56E4CkGHu9tpx93ofg3u8jcXACfgfse7gQ0d/9uzkdYnTVAg9nYDCzv+SMHpJZaIhwIR8VAgIh4KRMRDgYh4KBARDwUi4qFARDwUiIiHAhHxUCAiHgpExEOBiHgoEBEPBSLioUBEPBSIiIcCEfFQICIeCkTEQ4GIeCgQEQ8FIuKhQEQ8FIiIhwIR8VAgIh4KRMRDgYh4KBARDwUi4qFARDwUiIiHAhHxUCAiHgpExMMykCOGs6RYahm3T/a5YxnIGxm3H2yyColhSMbtD1gsIgTLQP6dcfvTTFYheRsKjMo4I+tzJxjLQPZk3H4q0MtiIZKrS8n2PDoE7DNaiznLQHZk3H4YMMtiIZKbVmB+xhkvAu0GawnCMpBtBjOWACcazJF8LAI+mHGGxfMmGOuXWH/LOGMQ8CRwUvblSGA3AgsN5mwwmBGM9fcg6wxmHAdsBr4K9DaYJ7ZOBh4ClhnNW2s0J4hW43kPANcazBkE3IbbhT8ObAX2A3WD2dK4VuBY4FxgEtm/9+i0FdhuNCsI60A2ALuBMUbzhgJXGM2S9Pw89gK6Yv0Sqw6sNJ4p5fQ6sDr2IroS4lisVST8ubYk4w7g1diL6EqIQA4AiwPMlfLYB9wSexHdEepo3tuBZwLNluK7iYK8yggVSDswg+wHMEr5PE4B3nt0Cnk+yFbcdxkinV4GrqRAH9eHPmHqbuy+UJJi2487IHVv7IU0Io8zCudToF2qBPE6cAnwfOyFNCqPQOq4o3SX5vBYkp5XgI8Bf4q9kGbkdU56Hbcn+TJ6414lm4EJHf9ZSHlftGE17he2JefHlXy14d57ng28FHktmcS4qslWYDxwHW73K+WyHvgwMA93tmChxbrszxHcl4nHATcAOyOtQ2y0A4/ijvadjPtHsBRiXxfrILAcOAH3y10J/DXmgqTbDgJP4P6BGwVcDGyMuqIArA93z2Ij//sFDwc+BJwCjAAGAv2JH3RVHcZdeWQ/bm+/A3ceR+FfQnWlVq8X5ktNkdzpX2QRDwUi4qFARDwUiIiHAhHxUCAiHgpExEOBiHgoEBEPBSLioUBEPBSIiIcCEfFQICIeCkTEQ4GIeCgQEY//ADn13vdim7/2AAAAAElFTkSuQmCC"
                    />
                  </defs>
                </svg>
              </a>
            </td>
          </tr>
        </template>
      </BaseTable>
      <TableNavControls
        v-if="reports.data"
        id="report-table"
        :paginationObject="reports"
        @page-selected="setPage"
      />
    </article>
  </section>
</template>

<script>
  import BaseButton from '~/components/base/BaseButton.vue';
  import BaseTable from '~/components/base/BaseTable.vue';
  import BaseSelectDropdown from '~/components/base/BaseSelectDropdown.vue';
  import TableNavControls from '~/components/dashboard/manage-users-and-permissions/table/TableNavControls.vue';
  import TableSearchbar from '~/components/dashboard/manage-users-and-permissions/table/TableSearchbar.vue';

  export default {
    name: 'ReportsTable',
    components: {
      BaseButton,
      BaseTable,
      BaseSelectDropdown,
      TableNavControls,
      TableSearchbar,
    },
    data: () => ({
      reports: {},
      page: null,
      search: null,
      users: [],
      primaryPocContact: '',
      primaryDataContact: '',
    }),
    computed: {
      queryParameters() {
        let query = [];
        if (this.page) {
          query.push(`page=${this.page}`);
        }
        if (this.search) {
          query.push(`search=${this.search}`);
        }
        return query.length > 0 ? `?${query.join('&')}` : '';
      },
    },
    async created() {
      await this.getReports();
      await this.getUserList();
    },
    methods: {
      setPage(page) {
        this.page = page;
        this.getReports();
        // document.getElementById('reports-table').scrollIntoView({ behavior: 'smooth' })
      },
      setSearch(search) {
        this.search = search;
        this.page = null;
        this.getReports();
      },
      async getReports() {
        const { data } = await axios.get(
          `/company-admin/report${this.queryParameters}`
        );
        this.reports = data;
      },
      async getUserList() {
        const { data } = await axios.get(`/company-admin/user/list`);
        this.users = data;
      },
      async setPrimaryPOC(userId, reportType) {
        const user = this.users.find((user) => user.id === userId);
        await axios.put(`/company-admin/report/poc`, {
          reportTypeId: reportType.id,
          contactsUserId: user.id,
        });
        this.$emit('refresh-users');
        this.getReports();
      },
      async setPrimaryDataContact(userId, reportType) {
        const user = this.users.find((user) => user.id === userId);
        await axios.put(`/company-admin/report/data-contact`, {
          reportTypeId: reportType.id,
          contactsUserId: user.id,
        });
        this.$emit('refresh-users');
        this.getReports();
      },
      isPocOptionSelected(user, report) {
        return (
          (report.consulting_meta?.contact_user_id &&
            user.id === report.consulting_meta.contact_user_id) ||
          false
        );
      },
      isDataOptionSelected(user, report) {
        return (
          (report.consulting_meta.data_user_id &&
            user.id === report.consulting_meta.data_user_id) ||
          false
        );
      },
      getReportUserOptions(report, dataContact = false) {
        return this.users
          .filter((user) => {
            if (dataContact && user.data_access === 'none') return false;
            return user.consulting_report_types.find(
              (reportType) => reportType.id === report.id
            );
          })
          .map((user) => ({
            value: user.id,
            label: `${user.first_name} ${user.last_name}`,
          }));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .reports-table {
    &__header {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 2rem;
      z-index: 0;
      border-top: none;
      gap: 1rem;
      z-index: 0;
    }
    &__body {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    &__body-title {
      margin: 0;
      font-size: 24px;
      font-weight: 400;
      font-style: italic;
    }
    &__body-header {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
    &__footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 1rem;
      margin: 0;
      padding: 0;
      background-color: transparent;
    }
    &__select {
      padding: 5px;
      // min-height: 25px;
    }
    &__report-link {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
      width: 100%;
      text-align: left;
      color: var(--itr-blue);
      font-weight: 700;
      font-style: italic;
    }
    &__contact-select :deep(.base-select-dropdown__button) {
      width: 100%;
      max-width: 300px;
      padding: 6px 12px !important;
      border-radius: 10px !important;
    }

    :deep(thead tr) {
      border-top: 1px solid var(--itr-grey-mid);
      border-bottom: 1px solid var(--itr-grey-mid);
    }
    :deep(td),
    :deep(th) {
      padding: 8px 16px !important;
      text-align: left !important;
    }
  }
</style>
